export default function IconDpdPost({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="13"
            viewBox="0 0 11 13"
            fill="none"
        >
            <path
                d="M7.14419 6.02656C7.09619 6.05856 7.01619 6.05856 6.96819 6.02656L6.69619 5.86656C6.68019 5.85056 6.64819 5.83456 6.63219 5.80256C6.61619 5.77056 6.60019 5.73856 6.60019 5.72256V5.40257C6.60019 5.35456 6.63219 5.27456 6.68019 5.25856L10.0242 3.30656L5.32019 0.746565C5.27219 0.682565 5.20819 0.666565 5.14419 0.666565C5.08019 0.666565 5.00019 0.682565 4.95219 0.714565L0.248188 3.27456L5.51219 6.34656C5.56019 6.37856 5.59219 6.44256 5.59219 6.49056V10.9546C5.59219 11.0186 5.54419 11.0826 5.49619 11.0986L5.20819 11.2586C5.19219 11.2746 5.16019 11.2746 5.12819 11.2746C5.09619 11.2746 5.06419 11.2746 5.03219 11.2586L4.74419 11.0986C4.69619 11.0666 4.66419 11.0026 4.66419 10.9546V6.97056C4.66419 6.93857 4.64819 6.90657 4.61619 6.89056L-0.0078125 4.18656V9.48256C-0.0078125 9.59456 0.0721875 9.75456 0.184188 9.80256L4.95219 12.6186C5.00019 12.6506 5.06419 12.6666 5.14419 12.6666C5.20819 12.6666 5.27219 12.6506 5.33619 12.6186L10.1202 9.80256C10.2162 9.73856 10.3122 9.59456 10.3122 9.48256V4.18656L7.14419 6.02656Z"
                fill="url(#paint0_linear_8297_44451)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_8297_44451"
                    x1="0.0419554"
                    y1="10.8505"
                    x2="5.25589"
                    y2="6.47549"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A90034" />
                    <stop offset="0.2717" stopColor="#BB0033" />
                    <stop offset="0.7226" stopColor="#D30032" />
                    <stop offset="1" stopColor="#DC0032" />
                </linearGradient>
            </defs>
        </svg>
    )
}
